
export default {
  init() {
    // JavaScript to be fired on pages that use content slider new
    $(document).ready(function () {


      $(window).on('resize load', function () {
        let marqueeSlider =  $('.layout-showcase_slider div.marquee-slider')
        if ($(window).width() < 961) {
          marqueeSlider.attr('uk-slider', 'autoplay: true; autoplay-interval: 0; center: true; pause-on-hover: true; velocity: .03; easing: linear')
        } else {
          marqueeSlider.attr('uk-slider', 'autoplay: true; autoplay-interval: 0; pause-on-hover: true; velocity: .03; easing: linear')
        }
      })
    })
  },
  finalize() {
    // JavaScript to be fired on pages that use the alternating section layout, after the init JS
  },
};
// autoplay: true; autoplay-interval: 0;
// autoplay: true; autoplay-interval: 0;



// WEBPACK FOOTER //
// ./scripts/routes/showcaseSlider.js